module.exports = __webpack_public_path__ + "img/blockchain_industry_02@2x.574e4a8b.png";